import { render, staticRenderFns } from "./productHome.vue?vue&type=template&id=ddb23774&"
import script from "./productHome.vue?vue&type=script&lang=ts&"
export * from "./productHome.vue?vue&type=script&lang=ts&"
import style0 from "./productHome.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports